var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#fff",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.003 21.6H3.998c-1.06-.002-2.075-.424-2.824-1.173S.002 18.663 0 17.603V6.398c.002-1.06.424-2.075 1.173-2.824S2.938 2.402 3.998 2.4h16.005a4.01 4.01 0 0 1 2.825 1.173A4 4 0 0 1 24 6.398v11.205c-.002 1.06-.424 2.075-1.173 2.824s-1.765 1.171-2.825 1.173zM3.998 3.998a2.4 2.4 0 0 0-2.4 2.4v11.205a2.4 2.4 0 0 0 2.4 2.4h16.005a2.4 2.4 0 0 0 2.4-2.4V6.398a2.4 2.4 0 0 0-2.4-2.4H3.998zM12 11.7a5.6 5.6 0 0 1-3.255-1.043L5.138 8.085c-.177-.123-.298-.312-.336-.524s.01-.431.133-.608.312-.298.524-.336.431.01.608.133l3.608 2.573a4.01 4.01 0 0 0 4.658 0l3.6-2.572a.8.8 0 0 1 .583-.109c.201.04.38.155.499.322a.8.8 0 0 1 .141.576c-.029.203-.133.388-.293.516l-3.607 2.572c-.946.689-2.085 1.064-3.255 1.072z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.61bcf5a7cf926d4aa59755e3e6600bfc.svg";
export { ForwardRef as ReactComponent };